module.exports = __webpack_public_path__ + "images/pattern-2@2x.7701f0895e3b2c274f4f3ae794f38a69.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/pattern-2@2x.jpg
// module id = 1025
// module chunks = 0